import AppTabs from 'components/CustomTabs/AppTabs';
import React from 'react';
import { useTranslation } from "react-i18next";
import RateNurseTable from "./Component/Rate/RateNurseTable";
import RateSupportWorkerTable from "./Component/Rate/RateSupportWorkerTable";
import { useHistory, useLocation } from 'react-router';
import { WORKER_TYPE } from 'config/AppConfig';
 
const RateManagement = () => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const history = useHistory();

  const queryURL = new URLSearchParams(search);

  const workerType = queryURL.get('workerType');
  const activeTab = workerType === WORKER_TYPE.SUPPORT_WORKER ? 1 : 0;

  const tabs = [
    {
      id: 1,
      title: t('label.nurse'),
      component: RateNurseTable
    },
    {
      id: 2,
      title: t('label.supportWorker'),
      component: RateSupportWorkerTable
    }
  ];

  const redirectListRate = (tabIndex) => {
    const url = `/admin/rates?workerType=${tabIndex === 0 ? 'NURSE' : 'SUPPORT_WORKER'}`;
    history.push(url);
};

  return (
    <AppTabs
      swipeable={false}
      activeTab={activeTab}
      onChangeTab={redirectListRate}
      tabs={tabs.map(item => {
        const {
          title,
          component: Component
        } = item;
        return {
          tabLabel: title,
          tabContent: <Component />
        }
      })}
    />
  )
}

export default RateManagement;
